import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formElements } from '../../common';
import * as messageSections from './message-section-constants';
import './modify-message.scss';

export class ModifyMessageForm extends Component {

  getValue(section) {
    const { value } = this.props;
    return value && value.get(section);
  }

  getDefaultValue(section) {
    const { defaultValue } =this.props;
    return defaultValue && defaultValue.get(section);
  }

  /**
   * Clear out date range if no longer selected
   * @param {string} checkBoxSeciton : use date range checkbox section descriptor
   * @param {string} startDateSecion : start date section descriptor
   * @param {string} endDateSection : end date section descriptor
   * @param {bool} isChecked : true if date range will be used
   */
  handleDateRangeChange(checkBoxSection, startDateSecion, endDateSection, isChecked) {
    const { updateValue } = this.props;
    if(!isChecked) {
      updateValue(checkBoxSection, isChecked);
    } else {
      updateValue(checkBoxSection, isChecked);
    }
  }

  render() {
    const { updateValue, disabled, errors, showErrors } =this.props;

    var content = this.getValue(messageSections.contentSection);
    var defaultContent = this.getDefaultValue(messageSections.contentSection);

    var isDismissable = this.getValue(messageSections.dismissableSection);
    var defaultDismissable = this.getDefaultValue(messageSections.dismissableSection);
    var isChecked = isDismissable === undefined ? !!defaultDismissable : !!isDismissable;

    var useDateRange = this.getValue(messageSections.dateRangeSection);
    var defaultUseDateRange = this.getDefaultValue(messageSections.dateRangeSection);
    var isDateRangeChecked = useDateRange === undefined ? !!defaultUseDateRange : !!useDateRange;

    var startDate = this.getValue(messageSections.startSection);
    var defaultStartDate = this.getDefaultValue(messageSections.startSection);

    var endDate = this.getValue(messageSections.endSection);
    var defaultEndDate = this.getDefaultValue(messageSections.endSection);

    var startErrors = errors && errors.filter(val => val.sourceId === 'start');
    var endErrors = errors && errors.filter(val => val.sourceId === 'end');

    return (
      <div className='modify-message'>
        <formElements.TextElement
          id='content-edit'
          maxLength={500}
          response={content}
          defaultValue={defaultContent}
          onChange={val => updateValue(messageSections.contentSection, val)}
          ariaLabel={"Notification Content"}
          disabled={disabled}
          showErrors={showErrors}/>

        <label  htmlFor={'dismissable-edit'}>
          <input
            id='dismissable-edit'
            type="checkbox"
            onChange={e => updateValue(messageSections.dismissableSection, e.target.checked)}
            checked={isChecked}
            disabled={disabled} />
          Allow participants to dismiss this notification
        </label>
        <br/>
        <label  htmlFor={'date-range'}>
          <input
            id='date-range'
            type="checkbox"
            onChange={e => this.handleDateRangeChange(messageSections.dateRangeSection, messageSections.startSection, messageSections.endSection, e.target.checked)}
            checked={isDateRangeChecked}
            disabled={disabled} />
          Display this notification on certain days:
        </label>
        <div className='row date-range'>
          <div className="col-sm-5">
            <formElements.DateElement
              id='start-date'
              label="Start"
              onChange={value => updateValue(messageSections.startSection, value)}
              response={startDate}
              defaultValue={defaultStartDate}
              disabled={!isDateRangeChecked || disabled}
              errors={startErrors}
              showErrors={showErrors}
              css={{
                label: "col-sm-3"
              }}/>
          </div>
          <div className="col-sm-5">
            <formElements.DateElement
              id='end-date'
              label="End"
              onChange={value => updateValue(messageSections.endSection, value)}
              response={endDate}
              defaultValue={defaultEndDate}
              disabled={!isDateRangeChecked || disabled}
              errors={endErrors}
              showErrors={showErrors}
              css={{
                label: "col-sm-3"
              }}/>
          </div>
        </div>
      </div>
    );
  }
}

ModifyMessageForm.propTypes = {
  value : PropTypes.object,
  defaultValue : PropTypes.object,
  updateValue : PropTypes.func,
  disabled : PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default ModifyMessageForm;
